import { KibStandaloneLink } from '@chewy/kib-menus-react';
import { handleActions, ActionDef } from '@chewy/chat-library-common';

import '@chewy/kib-menus-styles/dist/styles/kib-standalone-link.css';

export interface NavLinkProps {
    href: string;
    label: string;
    action: ActionDef;
    widgetData?: Record<string, any>;
}

export default function NavLink({ href, label, action, widgetData }: NavLinkProps) {

    const handleClick = () => {
        // Call handleActions from registry
        handleActions(action, widgetData);
        };

    return (
        <KibStandaloneLink href={href} onClick={handleClick}>{label}</KibStandaloneLink>
    );
}

